import { jsx as i, Fragment as _, jsxs as y } from "react/jsx-runtime";
import { forwardRef as c } from "react";
import { S } from "./index-DoOsnuB6.js";
import { c as b } from "./index-BNmRGtA6.js";
import { c as d } from "./clsx-OuTLNxxd.js";
import { S as f } from "./Spinner-Drz3dWpe.js";
import './Button.css';const x = "_buttonBase_zynwb_75", h = "_button_zynwb_75", w = "_xxSmallSize_zynwb_119", B = "_xSmallSize_zynwb_127", g = "_smallSize_zynwb_135", p = "_defaultSize_zynwb_143", v = "_largeSize_zynwb_149", F = "_iconSize_zynwb_157", N = "_primary_zynwb_166", W = "_secondary_zynwb_175", j = "_tertiary_zynwb_188", V = "_ghost_zynwb_210", k = "_ghostBrand_zynwb_211", C = "_outline_zynwb_251", R = "_surface_zynwb_264", q = "_isFullWidth_zynwb_270", A = "_rounded_zynwb_274", t = {
  buttonBase: x,
  button: h,
  xxSmallSize: w,
  xSmallSize: B,
  smallSize: g,
  defaultSize: p,
  largeSize: v,
  iconSize: F,
  primary: N,
  secondary: W,
  tertiary: j,
  ghost: V,
  ghostBrand: k,
  outline: C,
  surface: R,
  isFullWidth: q,
  rounded: A
}, D = b(t.button, {
  variants: {
    variant: {
      default: t.primary,
      ghost: t.ghost,
      ghostBrand: t.ghostBrand,
      secondary: t.secondary,
      tertiary: t.tertiary,
      outline: t.outline,
      surface: t.surface
    },
    size: {
      "xx-small": t.xxSmallSize,
      "x-small": t.xSmallSize,
      small: t.smallSize,
      default: t.defaultSize,
      large: t.largeSize,
      icon: t.iconSize
    }
  },
  defaultVariants: {
    variant: "default",
    size: "default"
  }
}), z = c(
  ({ asChild: l = !1, className: n, disabled: e, pressed: a, ...o }, s) => {
    const r = l ? S : "button", m = a === void 0 ? void 0 : { "aria-pressed": a, "data-state": a ? "on" : "off" };
    return /* @__PURE__ */ i(
      r,
      {
        className: d(t.buttonBase, n),
        "data-cxy-name": "button-base",
        disabled: e,
        ref: s,
        ...o,
        ...m
      }
    );
  }
), E = c(
  ({ asChild: l, isLoading: n, loadingText: e, variant: a, ...o }, s) => /* @__PURE__ */ i(_, { children: n ? /* @__PURE__ */ i(u, { ...o, "aria-busy": n, disabled: n, ref: s, variant: a, children: /* @__PURE__ */ y(_, { children: [
    e || "Loading",
    /* @__PURE__ */ i(f, { size: "s", variant: a === "secondary" ? "dark" : "light" })
  ] }) }) : /* @__PURE__ */ i(u, { ...o, asChild: l, ref: s, variant: a }) })
), u = c(
  ({ className: l, isFullWidth: n, rounded: e, size: a, variant: o, ...s }, r) => /* @__PURE__ */ i(
    z,
    {
      className: d(
        D({ variant: o, size: a }),
        { [t.isFullWidth]: n, [t.rounded]: e },
        l
      ),
      "data-cxy-name": "button",
      "data-testid": "button-component",
      ref: r,
      ...s
    }
  )
);
E.displayName = "Button";
z.displayName = "ButtonBase";
export {
  E as B,
  z as a,
  D as b
};
